import React, { useState, useCallback } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../config/firebase";
import EnergyQuizPage1 from "./EnergyQuizPage1";
import EnergyQuizPage2 from "./EnergyQuizPage2";
import EnergyQuizPage3 from "./EnergyQuizPage3";

const EnergyMultiPageSurvey = () => {
  const navigate = useNavigate();
  const [quizData, setQuizData] = useState({
    // Page 1: Energy & Circadian Rhythm (Huberman-heavy)
    morningLight: "",
    sleepConsistency: "",
    afternoonEnergyDip: "",
    caffeineTiming: "",
    eveningLight: "",
    nsdrPractice: "",
    // Page 2: Hormones, Movement & Recovery (Stacy Sims + Huberman)
    exerciseFrequency: "",
    coldHeatExposure: "",
    menstrualTracking: "",
    stressLevels: "",
    proteinTiming: "",
    recoveryPractices: "",
    // Page 3: Nutrition, Gut & Demographics (upgraded)
    fermentedFoods: "",
    hydrationElectrolytes: "",
    supplementStack: [],
    biologicalSex: "",
    age: "",
    email: "",
  });

  const updateQuizData = useCallback((field, value) => {
    setQuizData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const nextPage = useCallback(() => {
    const path = window.location.pathname;
    const pageNum = parseInt(path.split("/").pop());
    if (pageNum < 3) {
      navigate(`/energy/quiz/${pageNum + 1}`);
    }
  }, [navigate]);

  const prevPage = useCallback(() => {
    const path = window.location.pathname;
    const pageNum = parseInt(path.split("/").pop());
    if (pageNum > 1) {
      navigate(`/energy/quiz/${pageNum - 1}`);
    } else {
      navigate("/energy");
    }
  }, [navigate]);

  const handleComplete = async () => {
    // Save to Firebase
    try {
      await addDoc(collection(db, "energyQuizResponses"), {
        ...quizData,
        completedAt: serverTimestamp(),
      });
    } catch (err) {
      console.error("Failed to save energy quiz response:", err);
    }

    // Store in localStorage for results page
    localStorage.setItem("energy_quiz_data", JSON.stringify(quizData));
    navigate("/energy/results");
  };

  return (
    <Routes>
      <Route
        path="1"
        element={
          <EnergyQuizPage1
            quizData={quizData}
            updateQuizData={updateQuizData}
            onNext={nextPage}
            onNavigationBack={prevPage}
            currentSection={1}
          />
        }
      />
      <Route
        path="2"
        element={
          <EnergyQuizPage2
            quizData={quizData}
            updateQuizData={updateQuizData}
            onNext={nextPage}
            onNavigationBack={prevPage}
            currentSection={2}
          />
        }
      />
      <Route
        path="3"
        element={
          <EnergyQuizPage3
            quizData={quizData}
            updateQuizData={updateQuizData}
            onComplete={handleComplete}
            onNavigationBack={prevPage}
            currentSection={3}
          />
        }
      />
      <Route
        path="*"
        element={
          <EnergyQuizPage1
            quizData={quizData}
            updateQuizData={updateQuizData}
            onNext={nextPage}
            onNavigationBack={prevPage}
            currentSection={1}
          />
        }
      />
    </Routes>
  );
};

export default EnergyMultiPageSurvey;
